import { useEffect, useState } from 'react'
import * as umServinceURL from './umServiceURL'
import useTranslate from '../../i18n/useTranslate'
import useCallApi from '../../utilities/axios'

export type TransT = {
    th: string
    en: string
}

export type OptType = {
    label: string
    value: string
}

export type ExpiredResponseType = {
    projectID: number
    projectNumber: string
    expiredDate: string
    projectName: TransT
    projectType: {
        id: number
        name: TransT
    }
    name: TransT
    title: TransT
    academicPosition: TransT
    isPhD: boolean
    researcherTypeName: TransT
    titleID: number
}

export type ExpiredSearchForm = {
    keyword?: string
    projectType?: number
    startDate: Date | string
    endDate: Date | string
}

export type ExpiredSearchProps = {
    userID?: number
    keyword?: string
    projectType?: number
    startDate: string
    endDate: string
}

const useSearchExpired = () => {
    const callApi = useCallApi()

    const getExpiredData = async (values: ExpiredSearchProps) => {
        const { data } = await callApi.axiosPost<ExpiredResponseType[]>({
            url: umServinceURL.getResultExpired,
            params: values,
        })

        return data
    }

    return { getExpiredData }
}

export default useSearchExpired
